import { createSelector } from '@ngrx/store';
import { MarketMessage, MessageTypes } from '../../modules/messages';
import { AppState } from '../app.state';

const getMessageState = (state: AppState) => state.messageState;

export const getMessages = createSelector(getMessageState, state => {
	const messsages = [...state.messages];
	return messsages.sort((a, b) => new Date(b.createDateTime).getTime() - new Date(a.createDateTime).getTime());
});
export const getMarketMessages = createSelector(getMessages, messages =>
	messages.filter(t => t.type === MessageTypes.MarketMessage)
);
export const getMarketAndImmediateMessages = createSelector(getMessages, messages =>
	messages.filter(t => t.type === MessageTypes.MarketMessage || t.type === MessageTypes.ImmediateMessage)
);
export const getUnreadMarketMessages = createSelector(getMarketMessages, messages => messages.filter(t => !t.isRead));
export const getUnreadMarketMessagesCount = createSelector(getUnreadMarketMessages, messages => messages.length);
export const getUnreadMarketAndImmediateMessages = createSelector(getMarketAndImmediateMessages, messages =>
	messages.filter(t => !t.isRead)
);

export const getMessagesLastUpdateTime = createSelector(getMessageState, state => state.marketLastUpdateTime);
export const getMofidMessagesLastUpdateTime = createSelector(getMessageState, state => state.mofidlastUpdateTime);
export const getMessagesLoading = createSelector(getMessageState, state => state.loading);

export const getMofidMessages = createSelector(getMessages, messages =>
	messages.filter(t => t.type === MessageTypes.MofidMessage)
);
export const getUnreadMofidMessages = createSelector(getMofidMessages, messages => messages.filter(t => !t.isRead));
export const getUnreadMofidMessagesCount = createSelector(getUnreadMofidMessages, messages => messages.length);
export const getMofidMessagePageState = createSelector(getMessageState, state => state.mofidPageState);
export const getMofidMessageLoadMore = createSelector(
	getMofidMessages,
	getMofidMessagePageState,
	(message, pageState) => {
		return (pageState.pageNo + 1) * pageState.pageSize <= message.length;
	}
);
export const getMofidMessageImages = createSelector(getMessageState, state => state.images);

export const getImmediateMessages = createSelector(getMessageState, state =>
	state.messages.filter(t => t.type === MessageTypes.ImmediateMessage)
);
export const getUnreadImmediateMessages = createSelector(getImmediateMessages, messages =>
	messages.filter(t => !t.isRead)
);
export const getUnreadImmediateMessagesCount = createSelector(getUnreadImmediateMessages, messages => messages.length);

export const getUnreadMessages = createSelector(
	getUnreadMarketAndImmediateMessages,
	getUnreadMofidMessages,
	(marketMessages, MofidMessage) => [...marketMessages, ...MofidMessage]
);

export const getImmediateMessagesBySymbol = (symbolIsin: string) =>
	createSelector(getImmediateMessages, messages =>
		messages.filter((t: MarketMessage) => t.isins?.includes(symbolIsin))
	);

export const getMessageIndexById = (id: string) =>
	createSelector(getMessageState, state => state.messages.findIndex(t => t.id === id || t.messageId === id));

export const getMessagesBySymbol = (symbolIsin: string) =>
	createSelector(getMarketMessages, messages => messages.filter((t: MarketMessage) => t.isins.includes(symbolIsin)));

export const getUnreadMarketMessagesBySymbol = (symbolIsin: string) =>
	createSelector(getUnreadMarketMessages, messages =>
		messages.filter((t: MarketMessage) => t.isins?.includes(symbolIsin))
	);
export const getUnreadImmediateMessagesBySymbol = (symbolIsin: string) =>
	createSelector(getUnreadImmediateMessages, messages =>
		messages.filter((t: MarketMessage) => t.isins?.includes(symbolIsin))
	);
export const getUnreadMofidMessagesBySymbol = (symbolIsin: string) =>
	createSelector(getUnreadMofidMessages, messages =>
		messages.filter((t: MarketMessage) => t.isins?.includes(symbolIsin))
	);
export const getUnreadMessagesBySymbol = (symbolIsin: string) =>
	createSelector(getUnreadMarketAndImmediateMessages, getUnreadMofidMessages, (marketMessages, MofidMessage) =>
		[...marketMessages, ...MofidMessage].filter((t: MarketMessage) => t.isins?.includes(symbolIsin))
	);
